document.addEventListener('DOMContentLoaded', (e) => {
  const accordions = document.querySelectorAll('[data-faq-card]');

  accordions.forEach((item) => {
    const title = item.querySelector('[data-faq-card-title]');
    title.addEventListener('click', () => item.classList.toggle('is_opened'));
  });
});
